import arbitrumOnePlugin from '@exodus/ethereumarbone-plugin';
import arbitrumOneSepoliaPlugin from '@exodus/ethereumarbonesepolia-plugin';
export const ethereumarbone = arbitrumOnePlugin;
export const ethereumarbonesepolia = arbitrumOneSepoliaPlugin;
